import React from 'react';
import { browserHistory } from 'react-router';
import _ from 'lodash';

import {
  ORDER_TYPE_TAKEAWAY,
} from '@arreeba/ristoranti-frontend-lib/lib/constants';


import { connect } from '../../util';
import Button from '../../components/button';
import Url from '../../lib/url';

const OrderNoDelivery = (props) => {
  if ( props.serviceOffline ) {
    return (
      <main>
        <div className="noDelivery">
          <h4 className="noDelivery__title">Gli ordini di {props.appName} sono momentaneamente sospesi!</h4>
        </div>
      </main>
    );
  }
  return (
    <main>
      <div className="noDelivery">
        <h4 className="noDelivery__title">{props.appName} non consegna nella tua zona!</h4>
        {props.isTakeAwayAvailable &&
          <div className="noDelivery__block">
            <p>Puoi comunque procedere con un ordine da asporto.</p>
            <Button
              type="next"
              onClick={() => browserHistory.push(Url.orderTakeAway(props.url.appId))}
              text="ASPORTO"
            />
          </div>
        }
        <div className="noDelivery__block">
          <p>oppure scegli un'altro indirizzo</p>
          <Button
            type="next"
            onClick={() => browserHistory.push(Url.orderDelivery(props.url.appId))}
            text="ALTRO INDIRIZZO"
          />
        </div>
      </div>
    </main>
  );
};

const mapStateToProps = (state, props) => ({
  appName: state.app.config.name,
  url: props.url,
  config: state.app.config,
  serviceOffline: props.location.query.offline,
  isTakeAwayAvailable: _.indexOf(state.app.config.order.types, ORDER_TYPE_TAKEAWAY) > -1,
});
export default connect(OrderNoDelivery, { mapStateToProps });



// WEBPACK FOOTER //
// ./src/containers/order/order-no-delivery.js